import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { ProjectsPortfolioPage } from '../../../features/projects/portfolio-page'
import { type ProjectPortfolioSearch, projectPortfolioSearchSchema } from '../../../features/projects/search'

export const Route = createFileRoute('/_app/projects/')({
  beforeLoad: ({ context }) => requirePermission(context.session, 'projects.read'),
  validateSearch: (search: Record<string, unknown>): ProjectPortfolioSearch =>
    projectPortfolioSearchSchema.parse(search),
  component: ProjectsPortfolioPage,
})
